var map = {
	"./EVO.png": 1620,
	"./Path 20295.png": 1621,
	"./ab-img.webp": 1622,
	"./ab-title-cn.webp": 1623,
	"./ab-title-en.webp": 1624,
	"./ag-img.png": 1625,
	"./ag-img.webp": 1626,
	"./ag-title-cn.webp": 1627,
	"./ag-title-en.webp": 1628,
	"./chess-img.webp": 1629,
	"./coin-img.webp": 1630,
	"./content-img.webp": 1631,
	"./dg-img.webp": 1632,
	"./dg-title-cn.webp": 1633,
	"./dg-title-en.webp": 1634,
	"./diamond-img.webp": 1635,
	"./dice-coin.webp": 1636,
	"./ea-img.webp": 1637,
	"./ea-title-cn.webp": 1638,
	"./ea-title-en.webp": 1639,
	"./evo-img.webp": 1640,
	"./evo-title-cn.webp": 1641,
	"./evo-title-en.webp": 1642,
	"./golddice-img.webp": 1643,
	"./gp-img.webp": 1644,
	"./gp-title-cn.webp": 1645,
	"./gp-title-en.webp": 1646,
	"./heart-coin-img.webp": 1647,
	"./lc-bg.webp": 1648,
	"./mg-img.webp": 1649,
	"./mg-title-cn.webp": 1650,
	"./mg-title-en.webp": 1651,
	"./pp-img.webp": 1652,
	"./pp-title-cn.webp": 1653,
	"./pp-title-en.webp": 1654,
	"./pt-img.webp": 1655,
	"./pt-title-cn.webp": 1656,
	"./pt-title-en.webp": 1657,
	"./sa-img.webp": 1658,
	"./sa-title-cn.webp": 1659,
	"./sa-title-en.webp": 1660,
	"./sbo-img.webp": 1661,
	"./sbo-title-cn.webp": 1662,
	"./sbo-title-en.webp": 1663,
	"./spade-img.webp": 1664,
	"./title-cn.webp": 1665,
	"./title-en.webp": 1666,
	"./white-spade-img.webp": 1667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1619;